/***
**Module Name: signin
 **File Name :  sign.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains signin page details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate, useLocation } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import $ from "jquery";
import * as Config from "../constants/Config";

import Footer from "../components/footer/Footer";
import { contentContext } from "../context/contentContext";
import moment from "moment";



const SignIn = () => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [buttonText, setButtonText] = useState('Log In');
  const [show, setShow] = useState(false);
  const [activeLoad, setActiveLoad] = useState("");
  const [config, setConfig] = useState({});
  const [activeLogintype, setActiveLogintype] = useState("loginpwd");

  const { welcomeMsg, setWelcomeMsg, clientData, multiSessionLoad, SetMultiSessionLoad, GetClientDataFunction, menus } = useContext(contentContext)

  const [locData, setLocData] = useState("");
  const comingFromEmail = localStorage.getItem("comingFromEmail");
  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/content");
    }
    setLocData(JSON.parse(localStorage.getItem("loc")));

  }, []);
  useEffect(() => {
    // Run websiteDefaults if available
    if (typeof window.websiteDefaults === "function") {
      window.websiteDefaults();
    }

    // Set config if site data exists
    if (window.site) {
      setConfig(window.site);
    }
  }, [window.site]);


  if (config.common && config.common.imagesCDN) {
    var img = config.common.imagesCDN;
  }



  const handleShowPopup = (msg) => {
    setErrMsg(msg)
    setShowPopup(true)

  }
  const onConfirm = () => {
    setErrMsg("")
    setShowPopup(false)
  };
  const onCancel = () => {
    setShowSessionPopup(false)
  }
  const handleKeypress = (e) => {
    //it triggers by pressing the enter key

    if ((e.key === "Enter")) {
      setTimeout(function () {
        handleSignIn();
      }, 1000);
    }
  };

  const handleLoginOtp = (e) => {
    setActiveLogintype("loginotp")
    const valid = emailValidation()

    if (valid) {
      localStorage.setItem("email", email);
      setActiveLoad("loginOtp")
      if (activeLoad == "") {
        signin();
      }
    } else {
      setActiveLoad("")
    }


  }
  const emailValidation = (e) => {
    let flag = true;
    const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
    if (regEx.test(email)) {
      setError("");

    } else if (!regEx.test(email) && email !== "") {
      setError("Email is Not Valid");
      flag = false;
    }
    if (email === "") {
      setError("Please Enter Email");
      flag = false;
    }
    return flag

  }
  const formValidation = (e) => {
    let flag = true;

    const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
    if (regEx.test(email)) {
      setError("");

    } else if (!regEx.test(email) && email !== "") {
      setError("Email is Not Valid");

      flag = false;
    }

    if (email === "" && pwd === "") {
      setError("Please Enter Email and Password");
      flag = false;

    }
    if (email === "") {
      setError("Please Enter Email");
      flag = false;

    }
    if (pwd === "") {
      setError("Please Enter Email and Password");
      flag = false;

    }
    if (email && pwd === "") {
      setError("Please Enter Password");
      flag = false;

    }


    if (flag) {
      if (activeLoad == "") {
        setActiveLoad("loginPwd")
        loginPwd();
      }
    }

  }
  const handleSignIn = (e) => {
    setActiveLogintype("loginpwd")

    // setButtonText("Login")
    // setShow(true)

    // if (buttonText === "Login") {

    formValidation();

    // }
  }
  const signoutsession = async () => {
    try {
      SetMultiSessionLoad(true)

      const response = await tmdbApi.SignOutUser({ emailId: email });
      console.log(response);
      if (response.result == "Success") {

        if (activeLogintype == "loginotp") {

          signin()
        } else {


          loginPwd()
        }
      } else {
        setError("Invalid Details");
      }

    } catch {
      setActiveLoad("")
      SetMultiSessionLoad(false)
      console.log("error");
    }
  }
  const handleShowSessionPopup = () => {
    setShowSessionPopup(true)
  }
  const GetClientDataFunctionSignin = async () => {
    try {

      const response = await tmdbApi.getClientData({});


      if (response.statusCode === 200) {

        const EMAILID = response?.result?.result?.[0]?.personalemail

        window.clarity("set", "orasi_client_email", EMAILID)

        if (response?.result?.result?.[0]?.companyid) {
          localStorage.setItem("companyid", response?.result?.result?.[0]?.companyid)
        } else {
          localStorage.removeItem("companyid")
        }
        window.location.replace("/moreinfo/" + localStorage.getItem("check"));
        localStorage.removeItem("check");

      }
    } catch {
      console.log("error");
    }
  };
  console.log("location.state", location.state)
  const loginPwd = async () => {
    try {

      const response = await tmdbApi.signin({
        "emailid": email,
        "logintype": "password",
        "password": pwd,
        "useragent": locData?.headers !== undefined ? locData?.headers : {}
      });
      console.log(response);
      console.log(response.result);
      if (response.result === "Invalid email or password") {
        setError(response.result);

      } else if (response.result === "user not found") {
        setError("User not Found. Please SignUp");

      } else if (response.result === "Please log in using OTP and set a password") {
        setError("Please log in using OTP and set a password");

      } else if (response.result === "REJECT") {

        handleShowPopup("Your account has not been approved.")

      } else if (response.result === "INACTIVE") {

        handleShowPopup("Your account has been deactivated.")

      }
      else if (response.result === "Session Already Exists") {

        setShowSessionPopup(true)
      }
      else if (response.result === "PENDING VERIFICATION") {
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/signup") }, 3000);

      } else if (response.result === "PENDING TERMS") {
        setError("Please Check And Accept Terms");
        setTimeout(function () { navigate("/terms/" + email) }, 3000);

      } else if (response.result === "PENDING REGISTRATION") {
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/signup") }, 3000);

      } else if (response.result === "user not found") {
        setError("User not Found. Please SignUp ");

      } else if (response.result === "PENDING APPROVAL") {
        setError("Please Wait For Admin Approval");
        setTimeout(function () { navigate("/message") }, 3000);
      } else if (response.result === "Invalid password") {
        setError("Invalid password");
      } else if (response.result === "Client not found") {
        setError("User not Found. Please SignUp ");
      } else if (response.result === "Invalid email") {
        setError("Invalid email");
      } else if (localStorage.getItem("check") && response.statusCode === 200) {
        console.log("came");


        localStorage.setItem("token", response.result.token);
        localStorage.setItem("flag", "flag");
        localStorage.setItem("clientid", response.result.clientid);
        localStorage.setItem("login", "setlogin");

        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        GetClientDataFunctionSignin();


      } 
      else if (response?.result?.token && comingFromEmail === "emailCart") {
        localStorage.removeItem("comingFromEmail");
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        localStorage.setItem("login", "setlogin");

        const currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);

        setWelcomeMsg(true);
        navigate("/cart");
      }
      else if (response.result && response.result.token) {

        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        localStorage.setItem("login", "setlogin");

        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        setWelcomeMsg(true)

        navigate("/content");
      }
      else {
        setError("Invalid Details");

      }
      setActiveLoad("")
    } catch {
      setActiveLoad("")
      console.log("error");
    }
  };

  const AddNotify = () => toast.success('Email Sent Successfully', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  },)


  const signin = async () => {
    try {
      const response = await tmdbApi.signin({
        "emailid": email,
        "logintype": "otp"
      });

      console.log(response);

      if (response.result === "PENDING VERIFICATION") {
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/signup") }, 3000);

      } else if (response.result === "PENDING TERMS") {
        setError("Please Check And Accept Terms ");
        setTimeout(function () { navigate("/terms/" + email) }, 3000);

      } else if (response.result === "PENDING REGISTRATION") {
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/signup") }, 3000);

      } else if (response.result === "user not found") {
        setError("User not Found. Please SignUp ");

      } else if (response.result === "PENDING APPROVAL") {
        setError("Please Wait For Admin Approval");
        setTimeout(function () { navigate("/message") }, 3000);
      }
      else if (response.result === "REJECT") {
        localStorage.setItem("rejected", response.result);
        handleShowPopup("Your account has not been approved.")

      } else if (response.result === "Invalid password") {
        setError("Invalid password");
      } else if (response.result === "Invalid email") {
        setError("Invalid email");
      } else if (response.result === "Client not found") {
        setError("User not Found. Please SignUp ");
      } else if (response.result === "INACTIVE") {
        localStorage.setItem("inactive", response.result);
        handleShowPopup("Your account has been deactivated.")

      } else if (response.result === "Session Already Exists") {

        setShowSessionPopup(true)
      } else if (response.result === "ACTIVE" || response.result === "Email Sent Successfully") {
        localStorage.setItem("loginuser", email);
        localStorage.setItem("login", "setlogin");
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        setWelcomeMsg(true)

        navigate("/loginotp");
      }
      else {
        setError("Invalid Details");

      }
      setActiveLoad("")
    } catch {
      setActiveLoad("")

      console.log("error");
    }
  };
  function handleClose() {
    localStorage.removeItem("formatsClick");
    navigate("/");
  }

  const handleMessage = (e) => {
    setError("");
  }
  const handleForgot = (e) => {
    const valid = emailValidation()
    setActiveLoad("forgotPwd")
    if (valid) {
      if (activeLoad == "") {
        forgotPassword();
      }
    } else {
      setActiveLoad("")
    }
  }

  const forgotPassword = async () => {
    try {
      const response = await tmdbApi.ForgotPassword({
        "emailid": email
      });
      console.log(response);
      if (response.statusCode == 200) {

        if (response.result === "PENDING VERIFICATION") {
          setError("Please Complete SignUp Process");
          setTimeout(function () { navigate("/signup") }, 3000);

        } else if (response.result === "PENDING TERMS") {
          setError("Please Check And Accept Terms ");
          setTimeout(function () { navigate("/terms/" + email) }, 3000);

        } else if (response.result === "PENDING REGISTRATION") {
          setError("Please Complete SignUp Process");
          setTimeout(function () { navigate("/signup") }, 3000);

        } else if (response.result === "Client not found") {
          setError("User not Found. Please SignUp ");

        } else if (response.result === "user not found") {
          setError("User not Found. Please SignUp ");

        } else if (response.result === "PENDING APPROVAL") {
          setError("Please Wait For Admin Approval");
          setTimeout(function () { navigate("/message") }, 3000);
        }
        else if (response.result === "REJECT") {
          localStorage.setItem("rejected", response.result);
          handleShowPopup("Your account has not been approved.")

        } else if (response.result === "INACTIVE") {
          localStorage.setItem("inactive", response.result);
          handleShowPopup("Your account has been deactivated.")

        }
        else if (response?.result == 'Email Sent Successfully') {
          AddNotify();
        }
        setActiveLoad("")
      } else {
        setActiveLoad("")
        setError("invalid Email Id");
        setTimeout(function () { setError("") }, 3000);
      }

    } catch {
      console.log("error");
      setActiveLoad("")

      setTimeout(function () { setError("") }, 3000);
    }
  };


  const cardWidth = $(".signin-graphic").width();

  return (
    <>

      <Modal className="access-denied" show={showPopup} id="access-denied-modal">
        <div className="modal-body enquiry-form" id="access-denied-body">
          <div className="container" id="access-denied-container">
            <button
              className="close-btn"
              id="access-denied-close-btn"
              onClick={e => onConfirm()}
            >
              <span className="material-icons" id="access-denied-close-icon">
                close
              </span>
            </button>

            <span
              className="material-icons access-denied-icon"
              id="access-denied-icon"
            >
              https
            </span>

            <h3 id="access-denied-title">Access Denied</h3>
            <p id="access-denied-error-msg">{errMsg}</p>
            <p id="access-denied-contact-msg">Please contact administrator</p>

            <button
              className="fill_btn yellow-gradient"
              id="access-denied-close-btn-footer"
              data-bs-toggle="modal"
              data-bs-target="#recommendModal"
              onClick={e => onConfirm()}
            >
              close
            </button>
          </div>
        </div>
      </Modal>

      <Modal className="access-denied" show={showSessionPopup} id="multi-session-modal">
        <div className="modal-body enquiry-form" id="multi-session-body">
          <div className="container" id="multi-session-container">
            <button
              className="close-btn"
              id="multi-session-close-btn"
              onClick={e => onCancel()}
            >
              <span className="material-icons" id="multi-session-close-icon">
                close
              </span>
            </button>

            <span
              className="material-icons access-denied-icon"
              id="multi-session-icon"
            >
              web_asset_off
            </span>

            <h3 id="multi-session-title">Multiple Sessions Found</h3>
            <p id="multi-session-description">
              Another session is running in another browser. Do you want to terminate that session?
            </p>

            <div className="popup-footer" id="multi-session-footer">
              <button
                className="fill_btn yellow-gradient"
                id="multi-session-yes-btn"
                data-bs-toggle="modal"
                data-bs-target="#recommendModal"
                onClick={e => signoutsession()}
              >
                {multiSessionLoad ? (
                  <img
                    src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                    className="loading-icon"
                    id="multi-session-loading-icon"
                  />
                ) : null}
                Yes
              </button>

              <button
                className="fill_btn"
                id="multi-session-no-btn"
                data-bs-toggle="modal"
                data-bs-target="#recommendModal"
                onClick={e => onCancel()}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <div className="header-wrapper">

        <a className="navbar-brand" onClick={handleClose}>
          <img src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`} alt="Logo" />

        </a>

        <p id="signin-signup-prompt" className="signup-prompt">
          Not Registered Yet?<a id="signin-signup-link" href="/signup" className="mx-2">Sign Up</a>
        </p>

      </div>


      <div className="sign-in-bg"></div>
      <div className="new-signin-wrapper">
        <div id="signin-wrapper" className="signin-wrapper">
          <a href="/">
            <img
              id="signin-logo"
              src={
                "https://d2aif2zmoi437u.cloudfront.net/orasi/client/resources/orasiv1/images/logoupdated.png?auto=compress,format"
              }
              className="logo"
            />
          </a>

          <div id="signin-body" className="signin-body">


            <div id="signin-section" className="signin-section emaillogin ">
              <p className="about-hero-subtitle text-center">Marketplace</p>
              <h1 id="signin-heading" className="bold-heading">Login</h1>


              <div id="signin-email-div" className="mb-3 mt-5 field-set">
                <label htmlFor="signin-email" className="form-label">
                  Email<span>*</span>
                </label>
                <input
                  id="signin-email"
                  type="text"
                  className="form-control"
                  placeholder="Enter Email"
                  name="emailid"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={(e) => handleMessage(e)}
                  onKeyPress={handleKeypress}
                  autoComplete="on"
                />
              </div>

              <div id="signin-password-div" className="mb-3 field-set">
                <label htmlFor="signin-password" className="form-label">
                  Password<span>*</span>
                </label>
                <input
                  id="signin-password"
                  type="password"
                  placeholder="Enter Password"
                  className="form-control"
                  onChange={(e) => setPwd(e.target.value)}
                  onFocus={(e) => handleMessage(e)}
                  onKeyPress={handleKeypress}
                />
              </div>



              <div id="signin-footer" className="signin-footer">
                {error ? (
                  <span
                    id="signin-error"
                    className="errormsg-floating"
                    style={{ fontWeight: "bold", color: "red" }}
                  >
                    {error}
                  </span>
                ) : (
                  ""
                )}

                <button
                  id="signin-pwd-btn"
                  className="custom-btn-primary about-hero-btn flex items-center justify-center gap-2"
                  onClick={(e) => handleSignIn(e)}
                >
                  {activeLoad === "loginPwd" && (
                    <img
                      id="signin-login-loading"
                      src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                      className="loading-icon"
                    />
                  )}
                  <span>Log In</span>
                  <span className="material-icons">north_east</span>
                </button>



                <button
                  id="signin-login-otp-btn"
                  className="custom-btn-primary about-hero-btn flex items-center justify-center gap-2"
                  onClick={(e) => handleLoginOtp(e)}
                >
                  {activeLoad === "loginOtp" && (
                    <img
                      id="signin-login-otp-loading"
                      src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                      className="loading-icon"
                    />
                  )}
                  <span>Login with OTP</span>
                  {/* <span className="material-icons">north_east</span> */}
                </button>


                {/* {buttonText === "Login" && email != "" ? ( */}
                {/* ) : null} */}
              </div>
              <button
                id="signin-forgot-btn"
                className="plain-btn-sm"
                onClick={(e) => handleForgot(e)}
              >
                {activeLoad === "forgotPwd" ? (
                  <img
                    id="signin-forgot-loading"
                    src={
                      img +
                      "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"
                    }
                    className="loading-icon"
                  />
                ) : null}
                Forgot your password?
              </button>
              {/* <p id="signin-signup-prompt" className="signup-prompt mt-5">
        Not Registered Yet?<a id="signin-signup-link" href="/signup" className="mx-2">Sign Up</a>
      </p> */}
            </div>
          </div>
        </div>
      </div>

      <Footer menus={menus} />

      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
    </>
  );
};

export default SignIn;
